<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="auto">
        <v-img
          alt="Erro imagem"
          eager
          max-height="300"
          max-width="300"
          src="@/assets/pacman.png"
          transition="animate__animated animate__headShake animate__slow"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="auto">
        <h1>Hum... Você não tem permissão para acessar esse conteúdo</h1>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="auto">
        <router-link to="/">Página Inicial</router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NaoAutorizado"
};
</script>
